import React, { useEffect, useState, useContext } from "react";
import { getConfiguration } from '../utils/configuration';
import { SeoContext } from "./SeoContextProvider";

export default function SeoBreadcrumb(props) {
    const conf =  getConfiguration();
    const cfgSeo = conf?.seo;
    const seoContext = useContext(SeoContext);
    const [seoNavBreadcrumb,setSeoNavBreadcrumb] = useState(null);

    useEffect(() => {
        try {
            if(conf?.ssb && seoContext?.jsonld?.xsp_breadcrumb) {
                const xspBreadcrumb =  JSON.parse(seoContext.jsonld?.xsp_breadcrumb);
                setSeoNavBreadcrumb(xspBreadcrumb?.itemListElement.map((b,index) => {
                    return <a key={index} href={b.item}>{b.name}&nbsp;{index < xspBreadcrumb.itemListElement.length-1 && '>' }</a>
                
                }));
            }
        }catch(err) {
                console.error(err);
                setSeoNavBreadcrumb(null);
        }

    },[seoContext?.jsonld?.xsp_breadcrumb])


    

    return (
        <>{seoNavBreadcrumb && <div className="seo-breadcrumb">{seoNavBreadcrumb}</div>}
        </>
    )
}